import React, { useCallback, useMemo } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Text } from '../../components/Donee/components/common/Text/Text';
import { GivelifyButton } from '../../components/Donee/components/common/Button/GivelifyButton';
import MetaTags from '../../components/MetaTags';

const StyledDiv = styled.div`
  padding: 30px;
  .buttons-wrapper {
    margin: auto;
    max-width: 300px;
    text-align: center;
    .app-clip {
      margin-bottom: 20px;
    }
  }
  a .app-clip-link {
    cursor: pointer;
  }
`;

const url = 'https://stage.givelify.com/clip/launch?donee_id=1071126706991463';
const AppClip: React.FC = () => {
  const handleClick = useCallback(() => {
    window.location.href = url;
  }, []);

  const metaTags = useMemo(
    () => ({
      title: 'App clip | Givelify',
      description: 'Givelify app clip',
      extraTags: (
        <meta
          name="apple-itunes-app"
          content="app-id=725815127, app-clip-bundle-id=com.pushcontrolz.Givelify.Clip, app-clip-display=card"
        />
      )
    }),
    []
  );

  return (
    <StyledDiv>
      <MetaTags {...metaTags} />
      <div className="buttons-wrapper">
        <GivelifyButton
          onClick={handleClick}
          className="app-clip"
        >
          App Clip
        </GivelifyButton>
        <Link to={url}>
          <Text
            variant="medium"
            className="app-clip-link"
            color="primaryGuidingViolet"
          >
            App Clip
          </Text>
        </Link>
      </div>
    </StyledDiv>
  );
};

export default AppClip;
